import { List } from "lodash";
import { Settings, SftpSettingsDTO } from "../../generated/api";

export const SET_THEME = "SET_THEME";
export const GET_SETTINGS = "GET_SETTINGS";
export const SET_SETTINGS = "SET_SETTINGS";
export const SET_SFTP_SETTINGS = "SET_SFTP_SETTINGS";
export const SAVE_SFTP_SETTINGS = "SAVE_SFTP_SETTINGS";
export const GET_SFTP_SETTINGS = "GET_SFTP_SETTINGS";
export const GET_SFTP_NAMES = "GET_SFTP_NAMES";
export const SET_SFTP_NAMES = "SET_SFTP_NAMES";

export const setTheme = (theme: any) => ({
  type: SET_THEME,
  theme,
});

export const setSettings = (internalSettings: Settings) => ({
  type: SET_SETTINGS,
  internalSettings,
});

export const setSftpSettings = (sftp: SftpSettingsDTO) => ({
  type: SET_SFTP_SETTINGS,
  sftp,
});

export const setSftpNames = (sftpNames: List<String>) => ({
  type: SET_SFTP_NAMES,
  sftpNames,
});

const initialState = {
  theme: "light",
  internalSettings: null,
  sftp: null,
};

export const componentReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_THEME:
      const { theme } = action;
      return { ...state, theme };
    case SET_SETTINGS:
      const { internalSettings } = action;
      return { ...state, internalSettings };
    case SET_SFTP_SETTINGS:
      const { sftp } = action;
      return { ...state, sftp };
    case SET_SFTP_NAMES:
      const { sftpNames } = action;
      return { ...state, sftpNames };
    default:
      return state;
  }
};
